export enum EnumQrCodeValidation {
  IDLE = 'IDLE',
  DATA_SENDING = 'DATA_SENDING',
  SUCCESS = 'SUCCESS',
  ALREADY_SCANNED = 'ALREADY_SCANNED',
  GENERIC_ERROR = 'GENERIC_ERROR',
}
